export default __webpack_public_path__ + "static/media/favorite.70b1bbb4.svg";